<template>
    <div>
        <forms-vue
            v-bind:title="title"
            v-bind:form="form"
            v-bind:submit_url="submit_url"
            v-bind:redirect_submit_url="redirect_submit_url"
            v-bind:redirect_submit_url_params="redirect_submit_url_params"
            v-bind:edit_get_url="edit_get_url"
            v-bind:watch="watch"
            v-bind:submit_in_url="submit_in_url"
        ></forms-vue>

        <div class="content">
            <div class="container container-height">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Fichas a Derivar</h3>
                            </div>
                            <div class="card-body options">
                                <div class="row">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Codigo</th>
                                                <th>Descripción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item, key) in items"
                                                :key="key"
                                            >
                                                <td>{{ item.codigo_ficha }}</td>
                                                <td>{{ item.descripcion }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    data() {
        return {
            title: "",
            submit_url: this.$route.fullPath,
            redirect_submit_url: "",
            redirect_submit_url_params: {},
            edit_get_url: "",
            submit_in_url: false,
            items: [],
            watch: [],
            form: [
                [
                    {
                        col: "12",
                        title: "Datos Generales	",
                        footer: {},
                        attrs: [
                            [
                                {
                                    pretty_name:
                                        "Destinatario a derivar las fichas:",
                                    name: "user_id",
                                    desc: "select",
                                    type: "select",
                                    extra: "",
                                    value: "",
                                    options: [],
                                    cols: "12",
                                },
                                {
                                    pretty_name: "Motivo de la derivación:",
                                    name: "descripcion",
                                    desc: "text",
                                    type: "textarea",
                                    value: "",
                                    cols: "12",
                                },
                            ],
                        ],
                        footer: {
                            buttons: [
                                {
                                    type: "button",
                                    text: "Cancelar",
                                    class: "btn btn-danger pull-left",
                                    route: "PendientesInformacionDocumentada",
                                },
                                {
                                    type: "submit",
                                    text: "Derivar",
                                    class: "btn btn-success pull-right",
                                    route: "PendientesInformacionDocumentada",
                                },
                            ],
                        },
                    },
                ],
            ],
        };
    },
    created() {
        this.redirect_submit_url_params=this.$route.params;
        if (this.$route.params.lugar === "AU") {
            this.moduloTitulo = "Auditoria - Derivar Ficcha";
        }else{
            this.moduloTitulo = "Ficha - Derivar Ficcha";
        }

        this.redirect_submit_url = "PendientesFicha";

        const data = {
            selects: {
                User: {},
            },
        };
        this.$root
            .Consulta(
                this.$root.UrlBase("selects/init"),
                data,
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.form[0][0].attrs[0][0].options = response.User;
            });

        const fichas = {
            fichas: this.$route.query.fichas.split(","),
        };
        this.$root
            .Consulta(
                this.$root.UrlBase(
                    "registros/acciones/derivar-fichas/derivacion/fichas"
                ),
                fichas,
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.items = response.fichas;
            });
    },
    watch: {},
};
</script>
